import { showErrorNotification, showInfoNotification, showSuccessNotification } from '../../components/widgets/notificationToaster';
import { useDialogManager } from '../../components/widgets/dialog';
import React, { useEffect } from 'react';
import { useFragment, useMutation } from 'react-relay';
import { graphql } from 'relay-runtime';
import GeneralConditionsAndMarketingDialog from 'src/components/widgets/GeneralConditionsAndMarketing/GeneralConditionsAndMarketingDialog';
import { useShouldAcceptTermsAndConditionsDialogFragment$key } from './__generated__/useShouldAcceptTermsAndConditionsDialogFragment.graphql';

// fragment
const useShouldAcceptTermsAndConditionsFragment = graphql`
    fragment useShouldAcceptTermsAndConditionsDialogFragment on Query {
        shouldAcceptTermsAndConditions
    }
`;

// mutation
const useAcceptTermsAndConditionsMutation = graphql`
    mutation useShouldAcceptTermsAndConditionsDialogAcceptTermsAndConditionsMutation($marketingAccepted: Boolean!) {
        acceptTermsAndConditions(marketingAccepted: $marketingAccepted)
    }
`;

const useShouldAcceptTermsAndConditionsDialog = (
    useShouldAcceptTermsAndConditionsFragmentKey: useShouldAcceptTermsAndConditionsDialogFragment$key | null,
    onAccepted?: () => void
) => {
    const shouldAcceptTermsAndConditions = useFragment(useShouldAcceptTermsAndConditionsFragment, useShouldAcceptTermsAndConditionsFragmentKey ?? null);
    const [acceptTermsAndConditions] = useMutation(useAcceptTermsAndConditionsMutation);
    const { showDialog, closeDialog } = useDialogManager();

    useEffect(() => {
        if (!useShouldAcceptTermsAndConditionsFragmentKey || !shouldAcceptTermsAndConditions) return;

        if (!shouldAcceptTermsAndConditions.shouldAcceptTermsAndConditions) {
            onAccepted?.();
            return;
        }

        showDialog(
            'accept-terms-and-conditions',
            <GeneralConditionsAndMarketingDialog
                onConfirm={(isThirdPartyChecked: boolean) => {
                    showInfoNotification({ message: 'Updating terms and conditions!' });

                    acceptTermsAndConditions({
                        variables: { marketingAccepted: isThirdPartyChecked },
                        onCompleted: () => {
                            showSuccessNotification({ message: 'Terms and conditions successfully saved!' });
                            closeDialog('accept-terms-and-conditions');

                            onAccepted?.();
                        },
                        onError: () => {
                            showErrorNotification({ message: 'Failed to save terms and conditions!' });
                        }
                    });
                }}
            />
        );
    }, [useShouldAcceptTermsAndConditionsFragmentKey, shouldAcceptTermsAndConditions?.shouldAcceptTermsAndConditions]);
};

export default useShouldAcceptTermsAndConditionsDialog;
